import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.753 8.462a.7.7 0 0 1 0-.924l.895-1.008a.7.7 0 0 0 .084-.819l-1.4-2.421a.7.7 0 0 0-.748-.336l-1.316.266a.7.7 0 0 1-.805-.462l-.427-1.281A.7.7 0 0 0 9.371 1h-2.8a.7.7 0 0 0-.7.476l-.391 1.28a.7.7 0 0 1-.805.463l-1.351-.266a.7.7 0 0 0-.7.336l-1.4 2.421a.7.7 0 0 0 .07.82l.89 1.007a.7.7 0 0 1-.001.924L1.294 9.47a.7.7 0 0 0-.07.819l1.4 2.421a.7.7 0 0 0 .749.336l1.316-.266a.7.7 0 0 1 .805.462l.427 1.281a.7.7 0 0 0 .7.476h2.8a.7.7 0 0 0 .664-.476l.427-1.28a.7.7 0 0 1 .805-.463l1.316.266a.7.7 0 0 0 .749-.336l1.4-2.421a.7.7 0 0 0-.085-.82zM12.71 9.4l.56.63-.896 1.554-.826-.168a2.1 2.1 0 0 0-2.415 1.4l-.266.783H7.075l-.252-.798a2.1 2.1 0 0 0-2.414-1.4l-.826.168-.91-1.546.56-.63a2.1 2.1 0 0 0 0-2.8l-.56-.63.896-1.54.826.168a2.1 2.1 0 0 0 2.414-1.4l.266-.79h1.792l.266.798a2.1 2.1 0 0 0 2.415 1.4l.826-.169.896 1.554-.56.63a2.1 2.1 0 0 0 0 2.786M7.97 5.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6m0 4.2a1.4 1.4 0 1 1 0-2.8 1.4 1.4 0 0 1 0 2.8"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })